import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ColumnNameByKeyPipe } from '../../../../pipes/column-name-by-key.pipe';
import { AsyncPipe } from '@angular/common';
import { TableType } from '../../../../../../../../models/shipment';
import { MatFormField, MatOption, MatSelect } from '@angular/material/select';
import { ColumnTypeByKeyPipe } from '../../../../pipes/column-type-by-key.pipe';
import { ColumnDataFormatsPipe } from '../../../../pipes/column-data-formats.pipe';

@Component({
  selector: 'app-column-item',
  standalone: true,
  templateUrl: './column-item.component.html',
  imports: [
    ColumnNameByKeyPipe,
    AsyncPipe,
    MatSelect,
    ColumnTypeByKeyPipe,
    ColumnDataFormatsPipe,
    MatOption,
    MatFormField,
    ReactiveFormsModule
  ],
  styleUrl: './column-item.component.scss'
})
export class ColumnItemComponent {
  @Input() columnGroup!: FormGroup;
  @Input() type!: TableType;
  @Output() columnDeleted = new EventEmitter();
}
